var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Loader'),_c('GameFrame',{ref:"view"}),(!_vm.$inApp && _vm.$store.state.mode === 'intro')?_c('CookieBar'):_vm._e(),_c('RotateDevice')],1)}
var staticRenderFns = []

export { render, staticRenderFns }